<button
  mat-button
  [matMenuTriggerFor]="menu"
  [disabled]="(itens || []).length < 2"
>
  <mat-icon>switch_account</mat-icon>
  {{selecionada?.nome || 'Escolha uma conta'}}
</button>
<mat-menu #menu="matMenu">
  <ui-search
    placeHolder="Digite o nome da conta"
    (submitEvent)="filtrar($event)"
    (click)="naoFecharMenu($event)"
  ></ui-search>
  <button
    mat-menu-item
    role="menuitemcheckbox"
    *ngFor="let item of itensFiltrados$ | async"
    (click)="selecionar(item)"
  >
    {{item.nome}}
  </button>
</mat-menu>